// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop-module--backToTop--2r-76"};